import { Img } from "components"

type Props = {
    title: string
    excerpt: string
    date: string
    imageSrc: string
    imageAlt: string
}

export function ArticleItem({ title, excerpt, date, imageSrc, imageAlt }: Props) {
    return (
        <div className="grid grid-cols-12 gap-4">
            <div className="col-span-3 self-center">
                <Img
                    src={imageSrc || "/placeholder.svg"}
                    alt={imageAlt}
                    className="object-cover"
                />
            </div>
            <div className="col-span-9">
                <a href="#" className="block text-pretty font-medium text-foreground hover:underline">
                    {title}
                </a>
                <p className="text-xs leading-5 text-muted-foreground line-clamp-2">{excerpt}</p>
                <div className="mt-2 flex items-center justify-between">
                    <a href="#" className="text-xs text-blue-900 hover:underline">
                        {date}
                    </a>
                    <a href="#" className="text-xs font-medium hover:underline">
                        Read Blog →
                    </a>
                </div>
            </div>
        </div>
    )
}
